import { render } from "./KaimonoCalc.vue?vue&type=template&id=2a3087a2&scoped=true"
import script from "./KaimonoCalc.vue?vue&type=script&lang=js"
export * from "./KaimonoCalc.vue?vue&type=script&lang=js"

import "./KaimonoCalc.vue?vue&type=style&index=0&id=2a3087a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3087a2"]])

export default __exports__